import { http } from '../../utils';
const controller = 'master-data/assets';
export const getAssets = async (page, pageSize, orderBy, searchCondition, modelId, objectId, objectGroupId, assetTypeId) => {
    return await http.get(controller, {
        params: {
            modelId,
            objectId,
            objectGroupId,
            assetTypeId,
            searchCondition,
            page,
            pageSize,
            orderBy
        }
    });
};
export const getAssetById = async (id) => {
    return http.get(`${controller}/${id}`);
};
export const addAsset = async (asset) => {
    return http.post(controller, asset);
};
export const updateAsset = async (id, asset) => {
    return await http.put(`${controller}/${id}`, asset);
};
export const deleteAsset = async (id) => {
    return await http.delete(`${controller}/${id}`);
};
export const getAllAsset = async (objectId, modelId, name, status) => {
    return await http.get(`${controller}/get-all`, {
        params: {
            objectId,
            modelId,
            name,
            status
        }
    });
};
export const getAssetsDropdown = async (objectId, modelId, name, status) => {
    return await http.get(`${controller}/dropdown`, {
        params: {
            objectId,
            modelId,
            name,
            status
        }
    });
};
export const getAssignmentByAssetId = async (assetId) => {
    return http.get(`${controller}/assignments/${assetId}`);
};
export const addAssignment = async (assignment) => {
    return http.post(`${controller}/assignments`, assignment);
};
export const deleteAssignment = async (id) => {
    return http.delete(`${controller}/assignments/${id}`);
};
